import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Spin, Result } from 'antd';

const AuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (token) {
      localStorage.setItem('token', token);
      // Brief delay to ensure token is set before redirecting which triggers auth check
      setTimeout(() => {
        window.location.href = '/'; 
      }, 100);
    } else {
      setError('Xác thực thất bại. Không nhận được mã thông báo.');
    }
  }, [searchParams, navigate]);

  if (error) {
    return (
      <Result
        status="error"
        title="Đăng nhập thất bại"
        subTitle={error}
        extra={[
          <a key="login" href="/login">Quay lại trang đăng nhập</a>
        ]}
      />
    );
  }

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column',
      gap: 16
    }}>
      <Spin size="large" />
      <p>Đang hoàn tất xác thực...</p>
    </div>
  );
};

export default AuthCallback;
